import {
  answerJoinRequest,
  create,
  createSkill,
  deleteSkill,
  fork,
  get,
  getGameInfo,
  join,
  list,
  listJoinRequests,
  listMembers,
  listMemberships,
  remove,
  removeMember,
  setGameMaster,
  setMode,
  update,
  updateSkill,
} from "./endpoints";

export { service } from "./endpoints";
export {
  AnswerJoinRequestRequest,
  CreateGameRequest,
  CreateGameResponse,
  EVERYONE_ROLE_ID,
  ForkGameRequest,
  ForkGameResponse,
  GameIdParams,
  GameInfo,
  GameMember,
  GameMemberParams,
  GameMembership,
  GameMode,
  GamePermission,
  GamePreset,
  GameRole,
  GameSummary,
  GameTitle,
  GetGameInfoResponse,
  GetGameResponse,
  JoinGameResponse,
  JoinRequest,
  ListGamesQuery,
  ListGamesResponse,
  ListJoinRequestsResponse,
  ListMembershipsQuery,
  ListMembershipsResponse,
  ListMembersResponse,
  LobbyCommandResponse,
  SelectGameMasterRequest,
  SetGameModeRequest,
  SetGameModeResponse,
  SkillChanges,
  SkillEdit,
  SkillParams,
  UpdateGameRequest,
  UpdateGameResponse,
  UpdateSkillRequest,
  UserGameMembership,
  WhoCanJoin,
} from "./schemas";
export { gameSocketPath, gameSocketRoute } from "./socket";

export const contract = {
  list,
  create,
  get,
  update,
  delete: remove,
  join,
  fork,
  members: { list: listMembers, delete: removeMember },
  joinRequests: { list: listJoinRequests, answer: answerJoinRequest },
  memberships: { list: listMemberships },
  gameInfo: { get: getGameInfo },
  skills: { create: createSkill, update: updateSkill, delete: deleteSkill },
  gameMaster: { set: setGameMaster },
  mode: { set: setMode },
} as const;
